export const Required = ({ children, style, slim }) => {
  return (
    <div
      style={{
        ...(slim
          ? {}
          : {
              background: '#eee',
              padding: 15,
              borderRadius: 8,
            }),
      }}
    >
      {!slim && (
        <div style={{ fontSize: 12, color: '#777', marginBottom: 5 }}>
          <b>Required</b>
        </div>
      )}
      <div style={style}>{children}</div>
    </div>
  );
};
